import { State } from '.';

export const selectors = {
    getAppLockTimeout: (
        state: State
    ): number => (state.appConfig && state.appConfig.appLockTimeout) || 0,
    getMenuState: (
        state: State
    ): boolean => state.menuState,
    getSystemName: (
        state: State
    ): Undefinable<string> => state.appConfig && state.appConfig.systemName
};
